// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import useBuyingList from "@store/Framework/Common/Hooks/useBuyingList/useBuyingList";
import useBuyingListState from "@store/Framework/Store/Bunzl/Pages/Reporting/StoreHooks/useBuyingListState";
import { toToolkitApplicationState } from "@toolkit/Framework/Store/ApplicationState";
import { useEffect, useRef } from "react";

const useFetchWhenUpdateBuyingListParams = () => {
    const initalApiParams = { page: 1, pageSize: 9, query: "" };
    const { setApiParams } = useBuyingListState();
    const { buyingLists, loading, setLoading, getBuyingLists } = useBuyingList();
    const apiParams = useAppSelector(state => toToolkitApplicationState(state).bunzl.pages.buyingList.apiParams);
    const hasloaded = useRef(false);
    // useEffect(() => {
    //     // eslint-disable-next-line no-constant-condition
    //     if (JSON.stringify(apiParams) !== JSON.stringify(initalApiParams)) {
    //         setApiParams(initalApiParams);
    //     }
    // }, []);
    useEffect(() => {
        if (!hasloaded.current) {
            hasloaded.current = true;
            return;
        }

        if (!buyingLists) {
            return;
        }

        const fetchBuyingListsWithNewParams = async () => {
            if (!loading) {
                setLoading(true);
            }
            await getBuyingLists(true);
            setLoading(false);
        };
        fetchBuyingListsWithNewParams();
    }, [apiParams.query, apiParams.page, apiParams.pageSize]);
    return apiParams;
};

export default useFetchWhenUpdateBuyingListParams;
